import { NavLink } from "react-router-dom";
import "./MobileNav.scss";

export default function MobileNav() {
  const isLoggedIn = !!localStorage.getItem("token");

  return (
    <div className="mobile-bottom-nav">

      {/* Home — always visible */}
      <NavLink
        to="/"
        end
        className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
      >
        <span className="nav-icon"></span>
        <span className="nav-text">Home</span>
      </NavLink>

      {/* POST-LOGIN ONLY */}
      {isLoggedIn && (
        <>
          <NavLink
            to="/expertview"
            className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
          >
            <span className="nav-icon"></span>
            <span className="nav-text">Expert View</span>
          </NavLink>

          <NavLink
            to="/MyView"
            className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
          >
            <span className="nav-icon"></span>
            <span className="nav-text">My View</span>
          </NavLink>
        </>
      )}

    </div>
  );
}
